import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-slate-800 py-16 md:py-24 border-y border-slate-700" data-id="element-145">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-slate-900 p-8 md:p-12 rounded-3xl border border-amber-500/20 shadow-2xl text-center" data-id="element-147">
          <div className="inline-flex items-center justify-center p-3 bg-amber-500/10 rounded-full mb-6" data-id="element-148">
            <TrendingUp className="w-8 h-8 text-amber-500" data-id="element-149" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-150">
            Lo que cambia en tus primeros 7 días
          </h2>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-151">
            Al seguir este método, dejarás de ver Marketplace como un lugar para
            comprar y empezarás a verlo como tu propio{' '}
            <span className="text-amber-400 font-bold" data-id="element-152">
              cajero automático personal
            </span>
            . En tu primera semana, tu objetivo es recuperar tu inversión y
            tener tus primeros $100 de ganancia neta en mano.
          </p>
        </motion.div>
      </div>
    </section>;
}